/* eslint-disable max-len */
import React, { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import ChooseLayoutShimmer from './chooseLayoutShimmer';
import MobileCarousel from './MobileCarousel';

export default function ChooseLayout() {
    const navigate = useNavigate()
    const { type } = useParams()
    const [loading, setLoading] = useState(false)
    const [hoveredTemplate, setHoveredTemplate] = useState(null)
    const [selectedTemplate, setSelectedTemplate] = useState('');
    const auctionTemplates = [
        {   id: 1, 
            name: 'Classic',
            routeName: 'classic',  
            description: 'A timeless design to complement any website.', 
            img_url: '/images/classic-template.png' 
        },
        { 
            id: 2, 
            name: 'Single Lot', 
            routeName: 'single-lot',
            description: 'A simple and powerful layout for single-lot auctions.', 
            img_url: '/images/singlelot-template.png' },
        { 
            id: 3, 
            name: 'Standalone',
            routeName: 'standalone', 
            description: 'A homepage-inspired design, ideal for standalone auctions.', 
            img_url: '/images/standalone-template.png' },
    ];
    
    /**
     * The function `handleTemplateSelect` sets the selected template to the provided template ID.
     */
    const handleTemplateSelect = (templateId) => {
        setSelectedTemplate(templateId);
    };

    return (
        !loading ? 
            <div className="overflow-x-hidden flex justify-center ">
                <div className=" md:my-[60px] mb-[29px] mt-[55px]">
                    <p className="sm:text-[34px] text-[25px] leading-normal text-center text-[#343434] font-medium">
                        Choose your {type} auction template</p>
                    {/* Desktop & Tablet View */}
                    <ul className="hidden lg:flex justify-center flex-wrap md:mt-10 mt-3">
                        {auctionTemplates.map((template) => (
                            <div
                                key={template.id}
                                className={`${template.id !== 3 ? 'lg:mr-[-64px] sm:mb-0 mb-7' : ''} w-auto`}
                                onMouseEnter={() => setHoveredTemplate(template.id)}
                                onMouseLeave={() => setHoveredTemplate(null)}
                            >
                                <label id='classic' data-testid={`classic-${template.id}`} >
                                    <input
                                        className='hidden'
                                        type="radio"
                                        name="template"
                                        value={template.id}
                                        checked={selectedTemplate === template.id}
                                        onChange={() => handleTemplateSelect(template.id)}
                                    />
                                    <div  data-testid={`template-${template.id}`} id='classic-template' className="relative classic-div">
                                        <img
                                            src={template.img_url}
                                            className={`classic-img ${hoveredTemplate === template.id ? 'brightness-50 cursor-pointer' : 'cursor-pointer'}`}
                                            alt={`${template.name}-img`}
                                            loading="lazy"
                                        />
                                        <div className={`absolute classic-btns top-[40%] left-[23%] ${hoveredTemplate === template.id ? 'sm:block hidden' : 'hidden'}`}>
                                            <button className="border border-[#FFFFFF] rounded-md text-[14px] text-white px-[31px] py-[12px] w-[233px]">Preview</button>
                                            <button type='button' onClick={() => navigate(`/auctions/${type}/create/${template.routeName}`)}>
                                                <p className="bg-[#282828] rounded-md text-[14px] text-white mt-2.5 font-medium px-[20px] py-[12px] w-[233px]">
                                                    Continue with this template
                                                </p>
                                            </button>
                                        </div>
                                    </div>
                                    <div className="mt-[-50px]">
                                        <p className="text-center sm:text-[22px] text-[20px] text-[#343434] font-medium">
                                            {template.name}</p>
                                        <p className="text-center sm:text-[16px] text-[15px] text-[#343434] 
                                            font-medium max-w-[325px] m-auto mt-2">{template.description}</p>
                                        <div className={`${hoveredTemplate === template.id ? 'block md:hidden' : 'hidden'} mt-2 flex flex-col items-center`}>
                                            <button className="border border-[#A1A1A9] rounded-md text-[14px] text-[#52525A] px-[31px] py-[5px] w-[233px]">Preview</button>
                                            <button type='button' onClick={() => navigate(`/auctions/${type}/create/${template.routeName}`)}>
                                                <p className="bg-[#282828] rounded-md text-[14px] text-white mt-2.5 font-medium px-[20px] py-[7px] w-[233px]">
                                                    Continue with this template
                                                </p>
                                            </button>
                                        </div>
                                    </div>
                                </label>
                            </div>
                        ))}
                    </ul>

                    <div className="lg:hidden">
                        <MobileCarousel items={auctionTemplates} type={type} navigate={navigate} />
                    </div>

                </div>
            </div>
            : <ChooseLayoutShimmer/>  
    )
}